import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../config';
import '../styles/admincart.css';

const AdminCart = () => {
  const { po_number } = useParams();
  const [poData, setPoData] = useState(null);
  const [carts, setCarts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchPoData = async () => {
      setIsLoading(true);
      // First try to use order data from navigation state
      if (location.state?.orderData) {
        setPoData(location.state.orderData);
        if (location.state.orderData.carts) {
          setCarts(location.state.orderData.carts);
        }
        setIsLoading(false);
        return;
      }

      // If no order data in state, fetch from get-po endpoint
      if (!token) {
        console.error('No token available');
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_BASE}/get-po/?po_number=${po_number}`, {
          method: 'GET',
          headers: {
            'Authorization': `Token ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setPoData(data);
          if (data.carts) {
            setCarts(data.carts);
          }
        } else {
          console.error('Failed to fetch PO data', response.status, response.statusText);
          setPoData(null);
          setCarts([]);
        }
      } catch (error) {
        console.error('Error:', error);
        setPoData(null);
        setCarts([]);
      }
      setIsLoading(false);
    };

    fetchPoData();
  }, [token, po_number, location.state]);

  // Function to handle back navigation
  const handleBack = () => {
    navigate('/admin');
  };

      // Function to handle cart selection
  const handleCartClick = (cartCode) => {
    // Generate start time when cart is clicked (when user actually starts checking)
    const pickingStartTime = new Date().toISOString();

    // Store in localStorage for the specific cart
    const storageKey = `pickingStartTime_${po_number}_${cartCode}`;
    localStorage.setItem(storageKey, pickingStartTime);

    console.log('AdminCart - Generated new pickingStartTime:', pickingStartTime);
    console.log('AdminCart - Stored in localStorage with key:', storageKey);

    navigate(`/admin/${po_number}/${cartCode}`, {
      state: {
        orderData: poData,
        pickingStartTime: pickingStartTime
      }
    });
  };

  // Function to handle the "Checkear" button
  const handleCheckPo = async () => {
    try {
      const response = await fetch(`${API_BASE}/check-po-manual/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
        body: JSON.stringify({ po_number }),
      });

      if (response.ok) {
        const result = await response.json();
        alert('PO verificado con éxito.');
        console.log('Response:', result);
      } else {
        console.error('Failed to verify PO', response.status, response.statusText);
        alert('Error al verificar el PO.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al intentar verificar el PO.');
    }
  };

  // Check if all carts are checked
  const allCartsChecked = carts.length > 0 && carts.every(cart => cart.checked);

  if (isLoading) {
    return (
      <div className="admincart-page">
        <button className="adminproductos-back-button" onClick={handleBack}>
          &#8592;
        </button>
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="admincart-page">
      <button className="adminproductos-back-button" onClick={handleBack}>
        &#8592;
      </button>

      <h1 className="po-heading">Pedido: {po_number}</h1>

      {/* Sección de Responsables */}
      {poData && (
        <div className="responsables-section">
          <h3 className="section-title">Responsables:</h3>
          <div className="responsables-list">
            {poData.item_responsable?.length > 0 && (
              <div className="responsable-item">
                <strong>Abarrote:</strong> {poData.item_responsable.map(responsable => responsable.name).join(", ")}
              </div>
            )}
            {poData.frozen_responsable?.length > 0 && (
              <div className="responsable-item">
                <strong>Frío:</strong> {poData.frozen_responsable.map(responsable => responsable.name).join(", ")}
              </div>
            )}
          </div>
        </div>
      )}

      <h2 className="section-subtitle">¿Qué quieres chequear?</h2>

      <div className="carts-list">
        {carts.length > 0 ? (
          carts.map((cart, index) => {
            const isCart = cart.code.startsWith('CART-');
            const isBasket = cart.code.startsWith('BASKET-');

            const displayText = isCart
              ? `ABARROTE Nº${cart.code.split('-')[1]}`
              : isBasket
              ? `FRÍO Nº${cart.code.split('-')[1]}`
              : cart.code;

            const isDisabled = cart.checked;

            return (
              <div key={index} className={`cart-item ${isDisabled ? 'checked' : ''}`}>
                <div className="cart-info" onClick={() => !isDisabled && handleCartClick(cart.code)}>
                  <div className="cart-display-text">{displayText}</div>
                </div>
                <div className={`status-circle ${isDisabled ? 'checked' : ''}`}></div>
              </div>
            );
          })
        ) : (
          <div className="no-carts">
            <p>No hay abarrotes asociados a este pedido.</p>
          </div>
        )}
      </div>

      {allCartsChecked && (
        <button className="check-po-button" onClick={handleCheckPo}>
          Checkear
        </button>
      )}
    </div>
  );
};

export default AdminCart;
